import { LOCALES } from 'i18n/locales';

export const customMappingOrAnnotationsSnackBarIntl = {
    [LOCALES.ENGLISH]: {
        'customMapping.alert': 'Custom mapping is available.',
        'customMapping.link': 'Open isolated views.',
        'customMapping.notification.label': 'Custom mapping or annotations'
    },
    [LOCALES.WELSH]: {
        'customMapping.alert': 'Mae mapio arferol ar gael.',
        'customMapping.link': 'Agor golwg gwahanedig.',
        'customMapping.notification.label': 'Custom mapping or annotations]'
    }
};
